import * as React from 'react';
import styled from 'styled-components';
import { color } from '@lendi-ui/color';
import { my, px, py } from '@lendi-ui/spacing';
import { Body } from '@lendi-ui/typography';
import { Article } from '../../utils/schema';
import { ArticleCta } from './ArticleCta';
import { EquityCalculator, HomeLoanRepaymentCalculator } from '../Widgets';

const InlineCtaWrapper = styled.div`
  ${my('md')}
  ${py('md')}
  ${px('xxs')}
  border-top: 1px solid ${color('shade.100')};
  border-bottom: 1px solid ${color('shade.100')};
`;

interface InlineCtaProps {
  children: React.ReactNode[];
}

export const InlineCtaHOC = (ctas: Article['contentCtas']) =>
  React.memo(({ children }: InlineCtaProps) => {
    const [firstChild] = children;

    // Find and show widgets
    if (typeof firstChild === 'string' && firstChild.trim().match(/^%%___widget\s.*%%$/i)) {
      const widgetTitle = firstChild
        .trim()
        .toLowerCase()
        .replace(/(^%%___widget\s|%%$)/g, '');

      switch (widgetTitle) {
        case 'equity':
          return <EquityCalculator />;
        case 'home-loan-repayment':
          return <HomeLoanRepaymentCalculator />;
      }
    }

    // Find and show Cta's
    if (typeof firstChild === 'string' && firstChild.trim().match(/^%%.*%%$/)) {
      const ctaTitle = firstChild
        .trim()
        .toLowerCase()
        .replace(/(^%%|%%$)/g, '');
      const cta = ctas.find((cta) => ctaTitle === cta.title.toLowerCase());

      if (cta) {
        return (
          <InlineCtaWrapper>
            <ArticleCta cta={cta} />
          </InlineCtaWrapper>
        );
      }
    }

    return (
      <Body size="md" my="md">
        {children}
      </Body>
    );
  });
